module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsSAAALEgHS3X78AAAATklEQVQokWP8f8q1gQE7eMBgumsBDjkGFgYGhnoccgcZGBhwamTCJUEIkK2RBZfEudt/7NMyTf5T3UayNTL+/4/qGhMT3M6jio2jGvEAABxFEHoXPxQSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tu_3.1.1.png
// module id = xItl
// module chunks = 0